import { parseDate, roundToXDecimals } from '@ais-ui/utils';
import { QueryPointResult } from './queryPointResult';

export interface RadarTargetInfo {
  id: string;
  name: string;
  sog: string;
  cog: string;
  lastRadarReport: Date | null;
  lastRadarLatitude: string;
  lastRadarLongitude: string;
  lastOrigin: string;
  latitude: number;
  longitude: number;
  mmsi: string;
  targetType: string;
}

const desiredTargetIds: string[] = [
  'id',
  'name',
  'sog',
  'cog',
  'lastorigin',
  'mmsi',
  // New IDs
  'datetime_radar_last_report',
  'lat_radar_last_report',
  'lon_radar_last_report',
  'datetime_last_report',
  'lat_last_report',
  'lon_last_report',
  // Old IDs (backward compatibility)
  'lastradarreport',
];

export function extractRadarTargetInfos(
  result: QueryPointResult,
): RadarTargetInfo[] {
  const radarTargetInfos: RadarTargetInfo[] = [];
  for (const target of result.targetInfo) {
    const rawRadarTargetInfo: { [key: string]: string } = {};
    for (const target_value of target.values) {
      // Here we map values by their ID
      if (desiredTargetIds.includes(target_value.id)) {
        rawRadarTargetInfo[target_value.id] = target_value.value;
      }
    }
    const mmsi = target['mmsi'] || rawRadarTargetInfo['mmsi'];

    const radarInfo: RadarTargetInfo = {
      id: rawRadarTargetInfo['id'],
      name: rawRadarTargetInfo['name'],
      sog: rawRadarTargetInfo['sog'],
      cog: rawRadarTargetInfo['cog'],
      lastRadarReport: parseDate(
        rawRadarTargetInfo['datetime_radar_last_report'] ??
          rawRadarTargetInfo['datetime_last_report'] ??
          rawRadarTargetInfo['lastradarreport'],
      ),
      lastRadarLatitude:
        rawRadarTargetInfo['lat_radar_last_report'] ??
        rawRadarTargetInfo['lat_last_report'] ??
        '',
      lastRadarLongitude:
        rawRadarTargetInfo['lon_radar_last_report'] ??
        rawRadarTargetInfo['lon_last_report'] ??
        '',
      lastOrigin: rawRadarTargetInfo['lastorigin'],
      latitude: target['lat']
        ? roundToXDecimals(target['lat'], 4)
        : target['lat'],
      longitude: target['lon']
        ? roundToXDecimals(target['lon'], 4)
        : target['lon'],
      mmsi: mmsi,
      targetType: target['type'],
    };
    radarTargetInfos.push(radarInfo);
  }

  return radarTargetInfos;
}
